module.exports = __webpack_public_path__ + "img/step4.df6affee.svg";